import { AxleMark, cn } from "@shared/ui";

type LogoLockupProps = {
  logoUrl: string;
  label: string;
  size?: "md" | "lg";
};

const LogoLockup = ({ logoUrl, label, size = "md" }: LogoLockupProps) => {
  // lg is the consent screen's hero lockup: prod's 64px circles at 1.375x, overlap scaled to match.
  const sizeClass = size === "lg" ? "size-[88px]" : "size-11";
  const overlapClass = size === "lg" ? "-ml-[11px]" : "-ml-2";

  return (
    <div
      role="img"
      aria-label={`Axle and ${label}`}
      className="flex items-center"
    >
      {/* The ring sits on a span: iOS WebKit clips a ringed, layered <svg> unevenly. */}
      <span
        className={cn(
          "relative z-10 shrink-0 rounded-full ring-2 ring-surface",
          sizeClass
        )}
      >
        <AxleMark aria-hidden className="block size-full" />
      </span>
      <span
        style={{ backgroundImage: `url("${logoUrl}")` }}
        className={cn(
          "shrink-0 rounded-full border border-subtle bg-surface bg-cover bg-center bg-no-repeat",
          overlapClass,
          sizeClass
        )}
      />
    </div>
  );
};

export default LogoLockup;
